import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { authFire, dbFirestore } from '../appFirebase';
import { updateDocToSubCollection, setDocToSubCollection } from './dbUtils';

// User Sessions
export const getUserSessions = async () => {
	const userId = authFire.currentUser.uid;
	const querySnapshot = await getDocs(collection(dbFirestore, `users/${userId}/events`));

	const userSessions = [];
	querySnapshot.forEach(userSession => {
		userSessions.push({ ...userSession.data() });
	});
	return userSessions;
};

// get User Session
export const getUserSession = async sessionId => {
	const userId = authFire.currentUser.uid;
	const userSessionsRef = doc(dbFirestore, `users/${userId}/events/${sessionId}`);

	const docSnap = await getDoc(userSessionsRef);
	return docSnap.exists() ? docSnap.data() : null;
};

export const registerUserToSession = async (sessionId, sessionData) => {
	const userId = authFire.currentUser.uid;
	await setDocToSubCollection(`users/${userId}/events/${sessionId}`, { userId, eventId: sessionId, ...sessionData });
	return { userId, eventId: sessionId, ...sessionData };
};

export const updateUserSession = async (sessionId, sessionData) => {
	const userId = authFire.currentUser.uid;
	await updateDocToSubCollection(`users/${userId}/events/${sessionId}`, { userId, eventId: sessionId, ...sessionData });
	return { userId, eventId: sessionId, ...sessionData };
};

export const updateUserSessionFeedback = async (sessionId, feedback) => {
	const userId = authFire.currentUser.uid;
	await updateDocToSubCollection(`users/${userId}/events/${sessionId}`, { userId, eventId: sessionId, feedback });
	return { userId, eventId: sessionId, feedback };
};
